import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin, Suggestion } from '../../aiSuggestionsPluginType';

export function applySuggestion({
	api,
	suggestion,
}: {
	api?: ExtractInjectionAPI<AiSuggestionsPlugin>;

	suggestion: Suggestion;
}): void {
	api?.core.actions.execute(({ tr }) => {
		api?.aiStreamingOrchestrator?.actions.startSession();
		suggestion.toolCalls.forEach((toolCall) => {
			let id: string | undefined;
			const initOptions = { hideLoadingScreen: true };

			switch (toolCall.name) {
				case 'wrap':
				case 'wrapNode':
					id = api?.aiStreamingOrchestrator?.actions.initAction(
						{
							type: toolCall.name,
							localId: toolCall.arguments.localId,
							wrapperAttrs: toolCall.arguments.wrapperAttrs,
							wrapperType: toolCall.arguments.wrapperType,
						},
						initOptions,
					);
					break;
				case 'setAttrs':
					id = api?.aiStreamingOrchestrator?.actions.initAction(
						{
							type: toolCall.name,
							localId: toolCall.arguments.localId,
							attrs: toolCall.arguments.attrs,
						},
						initOptions,
					);
					break;
				case 'removeNodes':
					id = api?.aiStreamingOrchestrator?.actions.initAction(
						{
							type: toolCall.name,
							localIds: toolCall.arguments.localIds,
						},
						initOptions,
					);
					break;
				case 'removeNode':
				case 'replaceNode':
				case 'insertNodeBefore':
				case 'insertNodeAfter':
					id = api?.aiStreamingOrchestrator?.actions.initAction(
						{
							type: toolCall.name,
							localId: toolCall.arguments.localId,
						},
						initOptions,
					);
					break;
				default:
					break;
			}

			if (id) {
				if ('value' in toolCall.arguments) {
					api?.aiStreamingOrchestrator?.actions.streamValue(id, toolCall.arguments.value);
				}
				api?.aiStreamingOrchestrator?.actions.finishAction(id, undefined);
			}
		});
		api?.aiStreamingOrchestrator?.actions.endSession();
		return tr;
	});
}
